import { useState } from 'react';

export const useIsTouchDevice = () => {
    const [isTouchDevice] = useState(
        () => 'ontouchstart' in window || navigator.maxTouchPoints > 0,
    );

    return isTouchDevice;
};
